export default __webpack_public_path__ + "static/media/2.5ff821c8.png";